module.exports = __webpack_public_path__ + "media/svg/km-18fb1391.svg";